import { motion } from 'framer-motion';
import { Clock } from 'lucide-react';

// Shared placeholder for primary tabs that do not have their subtabs built yet.
const ComingSoon = ({ item }) => {
  const Icon = item.icon;

  return (
    <motion.div
      initial={{ opacity: 0, y: 16 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
      className="mx-auto max-w-5xl px-5 py-12 sm:px-6 sm:py-16 lg:px-8"
    >
      <div className="flex items-start gap-4">
        <div className="flex h-12 w-12 flex-none items-center justify-center bg-ink-900">
          <Icon className="h-6 w-6 text-saffron-400" />
        </div>
        <div className="min-w-0">
          <p className="text-xs uppercase tracking-[0.22em] text-saffron-600">{item.tagline}</p>
          <h1 className="mt-2 font-display text-4xl font-light leading-tight tracking-tight text-ink-900 sm:text-5xl">
            {item.label}
          </h1>
        </div>
      </div>

      <p className="mt-6 max-w-2xl text-base leading-relaxed text-ink-700/85 sm:text-lg">
        {item.description}
      </p>

      <div className="mt-10 bg-sand-50 p-6 shadow-[0_30px_60px_-30px_rgba(6,18,15,0.35)] ring-1 ring-ink-900/10 sm:p-8">
        <div className="flex items-center gap-2">
          <Clock className="h-4 w-4 text-saffron-600" />
          <p className="text-xs font-semibold uppercase tracking-[0.18em] text-ink-600/70">
            Coming soon
          </p>
        </div>
        <p className="mt-3 font-display text-2xl font-light text-ink-900">
          {item.label} is being built now.
        </p>
        <p className="mt-2 max-w-xl text-sm leading-relaxed text-ink-700/80">
          These sections will live inside this tab:
        </p>

        <ul className="mt-6 grid gap-2 sm:grid-cols-2">
          {item.subtabs.map((subtab) => (
            <li
              key={subtab}
              className="flex items-center gap-3 bg-white px-4 py-3 text-sm text-ink-800 ring-1 ring-ink-900/10"
            >
              <span aria-hidden="true" className="h-1.5 w-1.5 flex-none bg-saffron-500" />
              {subtab}
            </li>
          ))}
        </ul>
      </div>
    </motion.div>
  );
};

export default ComingSoon;
